import React from 'react';
import ProgressBar from 'components/main/ProgressBar';
import HeaderButtons from './HeaderButtons';

import './Header.scss';
import RMSvgIcon, {
  RMSvgIconProps,
} from 'components/customComponents/CommonComponents/RMSvgIcon';
import { ButtonsListContainer } from 'components/Button';
import { IStyle } from 'Styles';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import HeaderTitle from './HeaderTitle/HeaderTitle';
import '../main/progressBar.scss';
import CustomBreadCrumbs from 'components/customComponents/TreeControl/CustomBreadCrumbs/CustomBreadCrumbs';
import { TreeNodeDTO } from 'business/models/Models';
interface HeaderProps {
  headerButtons?: any;
  iconProps?: RMSvgIconProps;
  title?: string;
  setTitle?: (title: string) => void;
  containerStyle?: any;
  isNewTheme?: boolean;
  extendedSection?: React.ReactNode;
  extendedCommandSection?: React.ReactNode;
  extendedActionSection?: Array<RMCustomButtonProps | React.ReactNode>;
  breadCrumbs?: TreeNodeDTO[];
}
const Header = ({
  headerButtons,
  iconProps,
  title,
  setTitle,
  containerStyle = {},
  //TODO: Need to update header used every where according to the new UI and remove this flag
  isNewTheme = false,
  extendedSection = null,
  extendedCommandSection = null,
  extendedActionSection = null,
  breadCrumbs,
}: HeaderProps) => {
  return (
    <div
      id="header-wrapper"
      className="flex flex-row bg-[#E0E0E0] w-full !h-[10.6vh] items-center justify-between"
    >
      <div
        id="header-content"
        className="flex flex-1 max-w-[43%] flex-col items-start justify-center gap-1 h-full"
      >
        <div id="header-title-content" className="flex flex-col w-full truncate">
          {iconProps && (
            <RMSvgIcon
              subfolder={iconProps.subfolder}
              {...iconProps}
              style={{ marginRight: '1%' }}
            />
          )}
          <HeaderTitle
            title={title}
            {...(setTitle && { setTitle })}
            isNewTheme={isNewTheme}
          />
        </div>
        {breadCrumbs && (
          <div id="header-breadcrumbs" className="w-full text-ellipsis ml-4">
            <CustomBreadCrumbs
              isProteinControl={false}
              isScreenControl={false}
              treeNodes={undefined}
              breadCrumbs={breadCrumbs}
              hideTreeNodes={true}
            />
          </div>
        )}
      </div>
      <div
        id="header-extended-command-wrapper"
        className="flex-grow flex flex-row items-center h-full justify-end"
      >
        {extendedCommandSection && (
          <div
            id="header-extended-command-section"
            className="h-full flex flex-row items-center"
            style={{
              ...(extendedCommandSection && { marginRight: '10px' }),
            }}
          >
            <div id="header-extended-command-container" className="flex w-full h-full">
              <div id="header-command-divider-left" style={styles.verticalLine} />
              {extendedCommandSection}
            </div>
            <div id="header-command-divider-right" style={styles.verticalLine} />
          </div>
        )}

        {isNewTheme ? (
          headerButtons?.length > 0 && (
            <ButtonsListContainer
              containerStyleClass="align-items-center gap-x-6 mr-3"
              buttonsList={headerButtons}
            />
          )
        ) : (
          <HeaderButtons buttons={headerButtons} />
        )}

        {extendedSection && (
          <div
            id="header-extended-section"
            className="h-full flex flex-row items-center"
            style={{
              ...(extendedActionSection && { marginRight: '0px' }),
            }}
          >
            <div
              id="header-extended-divider"
              style={{ ...styles.verticalLine, marginLeft: '10px' }}
            />
            <div id="header-extended-container" className="flex w-full h-full">
              {extendedSection}
            </div>
          </div>
        )}

        {extendedActionSection && (
          <div
            id="header-extended-action-section"
            className="h-full flex flex-row items-center"
          >
            <div id="header-action-divider" style={styles.verticalLine} />
            <div id="header-action-container" className="flex w-full h-full">
              <ButtonsListContainer
                containerStyleClass="align-items-center"
                buttonsList={extendedActionSection}
              />
            </div>
          </div>
        )}
      </div>
      <ProgressBar text="Generating Images..." />
    </div>
  );
};

const styles: IStyle = {
  verticalLine: {
    borderLeft: '1px solid #888888',
    height: '80%',

    alignSelf: 'center',
  },
};

export default Header;
